/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PaymentRequestDto } from '../models/payment-request-dto';
import { PaymentResultBaseResponse } from '../models/payment-result-base-response';
import { StripePaymentRequestDto } from '../models/stripe-payment-request-dto';
import { CashPaymentRequestDto } from '../models/cash-payment-request-dto';
import { CardPaymentRequestDto } from '../models/card-payment-request-dto';
import { RefundRequestDto } from '../models/refund-request-dto';
import { PaymentLinkResponseBaseResponse } from '../models/payment-link-response-base-response';
import { PaymentMethod } from '../models/payment-method';
import { BooleanBaseResponse } from '../models/boolean-base-response';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiPaymentProcessPost
   */
  static readonly ApiPaymentProcessPostPath = '/api/Payment/process';

  /**
   * Process payment using the best available method
   */
  apiPaymentProcessPost$Json$Response(params?: {
    body?: PaymentRequestDto
  }): Observable<StrictHttpResponse<PaymentResultBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.ApiPaymentProcessPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentResultBaseResponse>;
      })
    );
  }

  /**
   * Process payment using the best available method
   */
  apiPaymentProcessPost$Json(params?: {
    body?: PaymentRequestDto
  }): Observable<PaymentResultBaseResponse> {

    return this.apiPaymentProcessPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentResultBaseResponse>) => r.body as PaymentResultBaseResponse)
    );
  }

  /**
   * Path part for operation apiPaymentStripePost
   */
  static readonly ApiPaymentStripePostPath = '/api/Payment/stripe';

  /**
   * Process Stripe payment
   */
  apiPaymentStripePost$Json$Response(params?: {
    body?: StripePaymentRequestDto
  }): Observable<StrictHttpResponse<PaymentResultBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.ApiPaymentStripePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentResultBaseResponse>;
      })
    );
  }

  /**
   * Process Stripe payment
   */
  apiPaymentStripePost$Json(params?: {
    body?: StripePaymentRequestDto
  }): Observable<PaymentResultBaseResponse> {

    return this.apiPaymentStripePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentResultBaseResponse>) => r.body as PaymentResultBaseResponse)
    );
  }

  /**
   * Path part for operation apiPaymentCashPost
   */
  static readonly ApiPaymentCashPostPath = '/api/Payment/cash';

  /**
   * Process cash payment
   */
  apiPaymentCashPost$Json$Response(params?: {
    body?: CashPaymentRequestDto
  }): Observable<StrictHttpResponse<PaymentResultBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.ApiPaymentCashPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentResultBaseResponse>;
      })
    );
  }

  /**
   * Process cash payment
   */
  apiPaymentCashPost$Json(params?: {
    body?: CashPaymentRequestDto
  }): Observable<PaymentResultBaseResponse> {

    return this.apiPaymentCashPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentResultBaseResponse>) => r.body as PaymentResultBaseResponse)
    );
  }

  /**
   * Path part for operation apiPaymentCardPost
   */
  static readonly ApiPaymentCardPostPath = '/api/Payment/card';

  /**
   * Process card payment
   */
  apiPaymentCardPost$Json$Response(params?: {
    body?: CardPaymentRequestDto
  }): Observable<StrictHttpResponse<PaymentResultBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.ApiPaymentCardPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentResultBaseResponse>;
      })
    );
  }

  /**
   * Process card payment
   */
  apiPaymentCardPost$Json(params?: {
    body?: CardPaymentRequestDto
  }): Observable<PaymentResultBaseResponse> {

    return this.apiPaymentCardPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentResultBaseResponse>) => r.body as PaymentResultBaseResponse)
    );
  }

  /**
   * Path part for operation apiPaymentValidatePost
   */
  static readonly ApiPaymentValidatePostPath = '/api/Payment/validate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentValidatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentValidatePost$Plain$Response(params?: {
    body?: PaymentRequestDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.ApiPaymentValidatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPaymentValidatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentValidatePost$Plain(params?: {
    body?: PaymentRequestDto
  }): Observable<BooleanBaseResponse> {

    return this.apiPaymentValidatePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPaymentValidatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentValidatePost$Json$Response(params?: {
    body?: PaymentRequestDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.ApiPaymentValidatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPaymentValidatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPaymentValidatePost$Json(params?: {
    body?: PaymentRequestDto
  }): Observable<BooleanBaseResponse> {

    return this.apiPaymentValidatePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiPaymentRefundTransactionIdPost
   */
  static readonly ApiPaymentRefundTransactionIdPostPath = '/api/Payment/refund/{transactionId}';

  /**
   * Process refund
   */
  apiPaymentRefundTransactionIdPost$Json$Response(params: {
    transactionId: string;
    body?: RefundRequestDto
  }): Observable<StrictHttpResponse<PaymentResultBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.ApiPaymentRefundTransactionIdPostPath, 'post');
    if (params) {
      rb.path('transactionId', params.transactionId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentResultBaseResponse>;
      })
    );
  }

  /**
   * Process refund
   */
  apiPaymentRefundTransactionIdPost$Json(params: {
    transactionId: string;
    body?: RefundRequestDto
  }): Observable<PaymentResultBaseResponse> {

    return this.apiPaymentRefundTransactionIdPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentResultBaseResponse>) => r.body as PaymentResultBaseResponse)
    );
  }

  /**
   * Path part for operation apiPaymentStatusTransactionIdGet
   */
  static readonly ApiPaymentStatusTransactionIdGetPath = '/api/Payment/status/{transactionId}';

  /**
   * Get payment status
   */
  apiPaymentStatusTransactionIdGet$Json$Response(params: {
    transactionId: string;
  }): Observable<StrictHttpResponse<PaymentResultBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.ApiPaymentStatusTransactionIdGetPath, 'get');
    if (params) {
      rb.path('transactionId', params.transactionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentResultBaseResponse>;
      })
    );
  }

  /**
   * Get payment status
   */
  apiPaymentStatusTransactionIdGet$Json(params: {
    transactionId: string;
  }): Observable<PaymentResultBaseResponse> {

    return this.apiPaymentStatusTransactionIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentResultBaseResponse>) => r.body as PaymentResultBaseResponse)
    );
  }

  /**
   * Path part for operation apiPaymentLinkPost
   */
  static readonly ApiPaymentLinkPostPath = '/api/Payment/link';

  /**
   * Create payment link
   */
  apiPaymentLinkPost$Json$Response(params?: {
    body?: PaymentRequestDto
  }): Observable<StrictHttpResponse<PaymentLinkResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.ApiPaymentLinkPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaymentLinkResponseBaseResponse>;
      })
    );
  }

  /**
   * Create payment link
   */
  apiPaymentLinkPost$Json(params?: {
    body?: PaymentRequestDto
  }): Observable<PaymentLinkResponseBaseResponse> {

    return this.apiPaymentLinkPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PaymentLinkResponseBaseResponse>) => r.body as PaymentLinkResponseBaseResponse)
    );
  }

} 